import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { CirclePicker, SketchPicker } from 'react-color';

const ENDPOINT = "farbzuordnung"

export const Fields = ({handleChange, handleChangeColor, name, farbe, text}) => (
    <Grid container spacing={8}>

        <TextFieldHelper n={10} value={name} onChange={handleChange('name')} label="Name" />
        <SelectFieldWrapper n={2} name="Textfarbe">
            <Select
                key={text+"text"}
                value={text}
                onChange={handleChange('text')}
                inputProps={{
                        id: text,
                }}
                autoWidth
            >
                <MenuItem value={"#000"}>Schwarz</MenuItem>
                <MenuItem value={"#fff"}>Weiß</MenuItem>
            </Select>
        </SelectFieldWrapper>
        <Grid item xs={12}><Divider /></Grid>

        <Grid item xs={6}>
            <CirclePicker color={farbe} onChangeComplete={handleChangeColor} />
        </Grid>
        <Grid item xs={6}>
            <SketchPicker color={farbe} onChangeComplete={handleChangeColor} />
        </Grid>


    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neue Farbzuordnung"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChangeColor={this.handleChangeColor} handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Farbzuordnung/NewEntry.js